// language=GraphQL
export const ALL_EMAIL_CONFIGS_QUERY = `query Query {
  emailConfigs: tenantEmailConfigs {
    id
    defaultInternalRecipientEmail
    internalBookingRecipientEmails
    bookingConfirmationTemplateId
    bookingConfirmationInternalTemplateId
    bookingRequestConfirmationTemplateId
    bookingWaitlistConfirmationTemplateId
    bookingWaitlistContingentCheckConfirmationTemplateId
    bookingCustomRequestTemplateId
    bookingPassportDataReminderTemplateId
    previewTravelInterestTemplateId
    contactFormTemplateId
    esimInstallationInfoTemplateId
  }
}`

// language=GraphQL
export const SINGLE_EMAIL_CONFIG_QUERY = `query Query($id: ID!) {
  emailConfig: tenantEmailConfig(id: $id) {
    id
    defaultInternalRecipientEmail
    internalBookingRecipientEmails
    bookingConfirmationTemplateId
    bookingConfirmationInternalTemplateId
    bookingRequestConfirmationTemplateId
    bookingWaitlistConfirmationTemplateId
    bookingWaitlistContingentCheckConfirmationTemplateId
    bookingCustomRequestTemplateId
    bookingPassportDataReminderTemplateId
    previewTravelInterestTemplateId
    contactFormTemplateId
    esimInstallationInfoTemplateId
  }
}`

// language=GraphQL
export const CREATE_EMAIL_CONFIG_MUTATION = `
  mutation Mutation($input: CreateTenantEmailConfigInput) {
    emailConfig: createTenantEmailConfig(input: $input) {
      id
      defaultInternalRecipientEmail
      internalBookingRecipientEmails
      bookingConfirmationTemplateId
      bookingConfirmationInternalTemplateId
      bookingRequestConfirmationTemplateId
      bookingWaitlistConfirmationTemplateId
      bookingWaitlistContingentCheckConfirmationTemplateId
      bookingCustomRequestTemplateId
      bookingPassportDataReminderTemplateId
      previewTravelInterestTemplateId
      contactFormTemplateId
      esimInstallationInfoTemplateId
    }
  }`

// language=GraphQL
export const UPDATE_EMAIL_CONFIG_MUTATION = `
  mutation Mutation($input: UpdateTenantEmailConfigInput) {
    emailConfig: updateTenantEmailConfig(input: $input) {
      id
      defaultInternalRecipientEmail
      internalBookingRecipientEmails
      bookingConfirmationTemplateId
      bookingConfirmationInternalTemplateId
      bookingRequestConfirmationTemplateId
      bookingWaitlistConfirmationTemplateId
      bookingWaitlistContingentCheckConfirmationTemplateId
      bookingCustomRequestTemplateId
      bookingPassportDataReminderTemplateId
      previewTravelInterestTemplateId
      contactFormTemplateId
      esimInstallationInfoTemplateId
    }
  }`

// language=GraphQL
export const DELETE_EMAIL_CONFIG_MUTATION = `
  mutation Mutation($input: DeleteTenantEmailConfigInput) {
    deleteTenantEmailConfig(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_EMAIL_CONFIG_MUTATION = `
  mutation Mutation($input: DeleteTenantEmailConfigInput) {
    forceDeleteTenantEmailConfig(input: $input) {
      success
    }
  }`
// language=GraphQL
export const EMAIL_CONFIGS_DEPENDENTS_QUERY = `query Query($id: ID!, $withTenants: Boolean = false) {
  groupedDependents: tenantEmailConfigDependents(id: $id) {
    tenants @include(if: $withTenants) {
      id
      name
      slug
      domain
      externalReference
    }
  }
}`
